import React, { useCallback } from 'react';

import { useUserContext } from 'providers/UserProvider';

import Table from 'components/common/Table';

import { productApi } from 'api';

import {
  getProductListColumns,
  PRODUCT_FILTER_OPTIONS,
} from 'constants/product';

const ManageProducts = () => {
  const { selectedTenant, selectedWarehouse } = useUserContext();
  const tenant = selectedTenant?.domains?.[0]?.domain;
  const warehouse = selectedWarehouse?.domain;

  const exportApi = useCallback(params => {
    return productApi.exportProduct(params);
  }, []);

  return (
    <Table
      title="Manage Products"
      apiService={productApi}
      exportApi={exportApi}
      sortable={true}
      columns={getProductListColumns(tenant, warehouse)}
      filterOptions={PRODUCT_FILTER_OPTIONS}
    />
  );
};

export default ManageProducts;
